import { useMemo } from 'react';

import { useIsBreakdownMode } from './useChartIsBreakdownMode';
import { useChartState } from './useChartState';

export const useCanLoadChart = () => {
  const chartState = useChartState();
  const isChartBreakdownMode = useIsBreakdownMode();

  return useMemo(() => {
    return (
      chartState.metrics && chartState.metrics.length && !isChartBreakdownMode
    );
  }, [chartState, isChartBreakdownMode]);
};
